module.exports = __webpack_public_path__ + "img/chat_e.e1403866.png";